import { wire } from 'hyperhtml/umd';
import '@updater-components/step-list';
import '../../../components/company-contact-card';
import '../../../components/company-contact-list';
import '../../../components/loading';
import { remote } from '../../../store/operations';
import { networkOnly } from '../../../store/utils';
import { when } from '../../../utils';
import { STEP_LIST } from '../../../constants';
import { isLocal, isLongDistance, isLargeHomeOrLongDistance } from '../utils';

const renderContent = route => (_, { getState, store }) => html => {
  const {
    currentMove: { movingCompany },
    moveIqMove: {
      fromAddressDetails: { address: fromAddress },
      toAddressDetails: { address: toAddress },
      moveDate: date,
    },
  } = getState();

  // prettier-ignore
  return html`
    ${when(isLocal(route), () => wire()`
    <upd-step-list value="${STEP_LIST}"></upd-step-list>
    `)}
    
    ${when(!movingCompany && isLongDistance(route), () => wire()`
    <upd-moveiq-loading
      id="loadingCompanies"
      value="${getCompaniesForLongDistanceLanding(store, { fromAddress, toAddress, date })}"
      overlay
    >
      <upd-moveiq-company-contact-list></upd-moveiq-company-contact-list>

      <div slot="loading-message">
        Finding your moving companies
      </div>
    </upd-moveiq-loading>
    `)}
    
    ${when(movingCompany && isLargeHomeOrLongDistance(route), () => wire()`
    <upd-moveiq-company-contact-card value="${movingCompany}">
    </upd-moveiq-company-contact-card>
    `)}
  `;
};

/**
 *
 * @param {ApolloClient} store the store instance for the query
 * @param {*} move moveDetails for surveyAvailability Call
 */
function getCompaniesForLongDistanceLanding({ query }, move) {
  return query(networkOnly(remote.moveIqSurveyAvailability(move))).then(
    ({ data: { moveIqSurveyAvailability } }) => moveIqSurveyAvailability || []
  );
}

export default renderContent;
